export const getRandomColor = () => {
  const min = 0x000000;
  const max = 0xFFFFFF;
  const color = Math.floor(Math.random() * (max - min + 1)) + min;
  return `#${color.toString(16).padStart(6, "0")}`;
};
